import { authGet } from "@api";

import { FetchLicenseResponse } from "@pages/settings/types";

export const fetchLicense = (
  licenseKey: string
): Promise<FetchLicenseResponse> => {
  return authGet<FetchLicenseResponse>(`/api/agent/licenses/${licenseKey}`);
};
